// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const ListHostingsApiAiHostingsGet200Item = zod.record(zod.string(), zod.unknown())

export type ListHostingsApiAiHostingsGet200Item = zod.input<typeof ListHostingsApiAiHostingsGet200Item>;
export type ListHostingsApiAiHostingsGet200ItemOutput = zod.output<typeof ListHostingsApiAiHostingsGet200Item>;
